<br>
<div>
  <p-table #dt [columns]="cols" [value]="signs" [paginator]="false" [autoLayout]="true">
    <ng-template pTemplate="caption">
      <p class="rubrik">Hantera Utmärkelser</p>
      <div class="d-flex justify-content-start gap-2"> <button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
            (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addSign();">Lägg till</button>
      </div>
      <br>
      <div>
        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
        <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
      <span class="ms-2">Antal poster: {{signs?.length}}</span>
      
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
          </p-sortIcon>
        </th>
        <th>Action</th>
      </tr>
      <tr *ngIf="types.length > 0">
        <th *ngFor="let col of columns" [ngSwitch]="col.field">
          <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <input *ngSwitchCase="'abbreviation'" pInputText type="text" [value]="dt.filters['abbreviation'] ? dt.filters['abbreviation'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
          <p-select appendTo="body" *ngSwitchCase="'typeName'" [options]="types" [style]="{'width':'100%', 'height':'40px'}" (onChange)="dt.filter($event.value, 'type', 'equals')"></p-select>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          {{rowData[col.field]}}
        </td>
        <td><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="remove(rowData)" title="Radera aktuell utmärkelse"></i><i class="fa fa-edit" style="font-size:12px;margin-left:10px;" (click)="edit(rowData)" title="Ändra aktuell utmärkelse"></i></span></td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog header="Editera utmärkelse" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-signs-edit [formdata]="formdata" [types]="types" (doSave)="saveSign($event)" (doCancel)="cancelEdit()"></app-admin-signs-edit>
  </p-dialog>

  <p-dialog header="Lägg till utmärkelse" [(visible)]="displayaddsign" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-signs-add [formdata]="formdata" [types]="types" (doSave)="saveAddSign($event)" (doCancel)="cancelAdd()"></app-admin-signs-add>
  </p-dialog>
